var moduleMap = {
	"./App": function() {
		return Promise.all([__webpack_require__.e(882), __webpack_require__.e(311)]).then(function() { return function() { return (__webpack_require__(7311)); }; });
	},
	"./Router": function() {
		return Promise.all([__webpack_require__.e(208), __webpack_require__.e(622)]).then(function() { return function() { return (__webpack_require__(3)); }; });
	},
	"./views/Home": function() {
		return Promise.all([__webpack_require__.e(882), __webpack_require__.e(773)]).then(function() { return function() { return (__webpack_require__(1773)); }; });
	},
	"./compositions/user": function() {
		return Promise.all([__webpack_require__.e(882), __webpack_require__.e(150)]).then(function() { return function() { return (__webpack_require__(2150)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});